<form id="copyUrlModal">
  <dialog-header>Link To "{{ copyFile.name }}"</dialog-header>
  <mat-dialog-content class="tw-mt-4">
    <div class="input-group">
      <input #copyUrlInput
        id="copyUrlInput"
        type="text"
        readonly
        class="form-control readonly-clean"
        value="{{ copyUrl }}"
        (focus)="selectInput()"
        [focusMe]="true"
      >
      <span class="input-group-addon u_clickable" aria-label="Copy URL" title="Copy URL" (mousedown)="copyToClipboard($event)">
        <streamline-icon name="copy" width="15" height="15"></streamline-icon>
      </span>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button type="submit" mat-flat-button color="primary" (click)="cancel()">
      Ok
    </button>
  </mat-dialog-actions>

</form>
